import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import customerReducer from "./slices/customerSlice";
import qrReducer from "./slices/qrSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        customer: customerReducer,
        qr: qrReducer,
    },
});
